import cn from 'classnames'

import { FC, ReactElement } from 'react'

import Calculator from 'components/ui/calculator'

import { ICoinPageCurrency } from 'config/coin-pages-list'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

import { useFloatingTrustpilot } from 'utils/use-trustpilot-widget'
import MobileAppBtn from 'components/global/mobile-app-link'

export const MainBlock: FC<{
  currenciesCount: string
  isSupported: boolean
  description: string
  pageCurrency: ICoinPageCurrency
  h1?: ReactElement
}> = ({ currenciesCount, isSupported, pageCurrency, h1, description }) => {
  const { t, replacePlaceholders } = useTranslation()

  useFloatingTrustpilot('trustpilot-target')

  return (
    <section className={styles.container}>
      <div className={styles['main-block']}>
        <div className={styles['main-block__background']}>
          <img
            width={1200}
            height={1200}
            src={
              pageCurrency.background && pageCurrency.background.data
                ? `https://cms.coinrabbit.io${pageCurrency.background.data.attributes.url}`
                : `/assets/coin-pages/backgrounds/${pageCurrency.code.toLowerCase()}.svg`
            }
            alt={t('coin_page_icon')}
          />
        </div>
        <div className={cn('container', styles['main-block__wrapper'])}>
          <div className={styles['description-header__tablet']}>
            <p className={styles.subtitle}>
              {h1 || (
                <span dangerouslySetInnerHTML={{
                  __html:
                    replacePlaceholders(t('get_instant_coint_loan_default_title'), {
                      styleSpan: styles.titlePage_Span,
                      styleFirstWord: styles.firstWord,
                      name: pageCurrency.name
                    })
                }}>
                </span>
              )}
            </p>
            <div className={styles['subtitle-text']}>
              <p>{t(description).trim() ? t(description) : (
                <>
                  <span>
                    {t('borrow_against')} {pageCurrency?.altName || pageCurrency.code.toUpperCase()} {t('for_unlimited_term')}
                    {', '}
                  </span>
                  <span>{t('crypto_without_selling')}</span>
                </>
              )}</p>
            </div>
          </div>

          <div className={styles.description}>
            <div className={styles['description-header']}>
              <h1 className={styles.subtitle}>
                {h1 || (
                  <span dangerouslySetInnerHTML={{
                    __html:
                      replacePlaceholders(t('get_instant_coint_loan_default_title'), {
                        styleSpan: styles.titlePage_Span,
                        styleFirstWord: styles.firstWord,
                        name: pageCurrency.name
                      })
                  }}>
                  </span>
                )}
              </h1>
              <div className={styles['subtitle-text']}>
                <p>{t(description).trim() ? t(description) : (
                  <>
                    <span>
                      {t('borrow_against')} {pageCurrency?.altName || pageCurrency.code.toUpperCase()} {t('for_unlimited_term')}
                      {', '}
                    </span>
                    <span>{t('crypto_without_selling')}</span>
                  </>
                )}</p>
              </div>
            </div>

            <div className={styles.advantages}>
              <div className={styles['advantages-item']}>
                <p className={styles['advantages-main']}>{t('safe')}</p>
                <p className={styles['advantages-text']}>
                  <span className={styles.nowrap}>{t('top_tier_security')},</span>
                  <span>{t('cold_wallet_storage')}</span>
                </p>
              </div>
              <div className={styles['advantages-item']}>
                <p className={styles['advantages-main']}>{t('easy')}</p>
                <p className={styles['advantages-text']}>
                  <span>{t('no_credit_check')}</span>
                </p>
              </div>
              <div className={styles['advantages-item']}>
                <p className={styles['advantages-main']}>{t('start')}</p>
                <p className={styles['advantages-text']}>{t('from')} $100</p>
              </div>
              <div className={styles['advantages-item']}>
                <p className={styles['advantages-main']}>{currenciesCount}</p>
                <p className={styles['advantages-text']}>{t('currencies')}</p>
              </div>

              <div className={cn(styles['advantages-item'],styles['partner-item'], styles['socials'])}>
                <p className={cn(styles['partner-title'], styles['desktop-only'])}>{t('download_the_app')}</p>
                <MobileAppBtn />         
              </div>
              <div className={cn(styles['advantages-item'], styles['partner-item'], styles['socials'])}>
                <p className={cn(styles['partner-title'], styles['desktop-only'])}>{t('rated_excellent')}</p>
                <p className={styles['advantages-text']}><div id="trustpilot-target" /></p>        
              </div>
            </div>
          </div>

          <div className={styles.calculator}>
            <Calculator pageCurrency={pageCurrency} />
          </div>
        </div>
      </div>
    </section>
  )
}
